module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue7.70fd02a1.jpg";